import { doc, runTransaction } from "firebase/firestore";
import { db } from "../../firebase/config";

/** Cash Out / COP — next global matrix fill (may slot before a later AFP serial). */
export async function allocateMatrixFillForCashOut() {
  const counterRef = doc(db, "autoFillMeta", "counters");
  return runTransaction(db, async (tx) => {
    const snap = await tx.get(counterRef);
    const current = snap.exists() ? Number(snap.data().matrixFillSeq) || 0 : 0;
    const fillSeq = current + 1;
    tx.set(counterRef, { matrixFillSeq: fillSeq }, { merge: true });
    return fillSeq;
  });
}

/**
 * AFP enrollment — next global matrix fill (strict counter; never skip a fill
 * when internal enrollmentSeq gaps exist, e.g. missing AFP-000016).
 */
export async function registerMatrixFillForAfpEnrollment(enrollmentSeq) {
  void enrollmentSeq;
  const counterRef = doc(db, "autoFillMeta", "counters");
  return runTransaction(db, async (tx) => {
    const snap = await tx.get(counterRef);
    const current = snap.exists() ? Number(snap.data().matrixFillSeq) || 0 : 0;
    const fillSeq = current + 1;
    tx.set(counterRef, { matrixFillSeq: fillSeq }, { merge: true });
    return fillSeq;
  });
}
